export const SUPPORTED_LOCALES = ['en', 'ar'] as const

export type Locale = (typeof SUPPORTED_LOCALES)[number]
export type Direction = 'ltr' | 'rtl'
export type LocalizedCopy<T> = Record<Locale, T>

export type NavItem = {
  key: 'home' | 'about' | 'services' | 'maintenance' | 'projects' | 'resources' | 'blog' | 'careers' | 'contact'
  slug: '' | 'about' | 'services' | 'maintenance-team' | 'projects' | 'resources' | 'blog' | 'careers' | 'contact'
  label: LocalizedCopy<string>
  /** Optional hash (anchor) appended to the route; when present the item is treated as an in-page anchor. */
  hash?: string
}

export type ServiceIconName =
  | 'hvac'
  | 'plumbing'
  | 'electrical'
  | 'elevators'
  | 'lowCurrent'
  | 'security'
  | 'fireAlarm'

export type ServiceItem = {
  id: string
  icon: ServiceIconName
  title: LocalizedCopy<string>
  description: LocalizedCopy<string>
  bullets: LocalizedCopy<string[]>
}

export type SolutionCategory = {
  id: string
  icon: 'industrial' | 'infrastructure' | 'commercial'
  title: LocalizedCopy<string>
  description: LocalizedCopy<string>
  bullets: LocalizedCopy<string[]>
}

export type PartnerLogo = {
  name: string
  src: string
}

export type StatItem = {
  id: string
  value: number
  suffix?: string
  label: LocalizedCopy<string>
}

export type ContactFormValues = {
  name: string
  email: string
  company: string
  phone: string
  address: string
  message: string
}

export type AppError = {
  type: 'network' | 'server' | 'unknown'
  message: string
  statusCode?: number
}

export type ProjectGalleryItem = {
  id: string
  imageSrc: string
  title: LocalizedCopy<string>
}

export type ProjectCategoryBlock = {
  id: string
  title: LocalizedCopy<string>
  subtitle: LocalizedCopy<string>
  items: ProjectGalleryItem[]
}

export type MotionPreference = 'system' | 'reduce'
